import { Component, EventEmitter, Input, NgZone, Output } from '@angular/core';
import { DeviceService } from '../../../services/device.service';
import { WindowRefService } from '../../../services/window.service';
import { Device } from '../models';

@Component({
  selector: 'search-menu',
  templateUrl: './search-menu.component.html',
  styleUrls: ['./search-menu.component.scss'],
  providers: [WindowRefService],
})
export class SearchMenuComponent {

  @Input() devices: Device[] = [];
  @Input() selectedDevice: Device;
  @Input() streamEnabled: boolean = false;
  searchText: string;
  @Output() streamRequest = new EventEmitter();

  constructor(
    private deviceService: DeviceService) {

  }

  public searchChanged(event) {
    this.deviceService.searchDevices(this.searchText);
  }

  public highlightDevice(device: Device) {
    this.deviceService.setDeviceHighlight(device, true);
  }

  public unHighlightDevice(device: Device) {
    this.deviceService.setDeviceHighlight(device, false);
  }

  public selectDevice(device: Device) {
    this.deviceService.setDeviceSelected(device);
  }

  public clearSearch() {
    this.searchText = "";
    this.deviceService.clearSearch();
  }

  public loadStream($event: any, device: Device) {
    $event.stopPropagation();
    $event.preventDefault();
    this.streamRequest.emit(device);
  }

}
